import service from '../config/axios.config';

export const fetchDrawerInfo = ( ) =>
  service.get(`/drawerInfo`);